import { NgModule } from '@angular/core';
import { ProductImageZoomModule } from './product-image-zoom/product-image-zoom.module';

@NgModule({
  imports: [ProductImageZoomModule],
})
export class ProductImageZoomComponentsModule {}
